import Component from '../core/Component';
import $ from 'jquery';

export default class Guide extends Component
{
    constructor($element)
    {
        super($element);
    }

    prepare()
    {
        if ($('.page-homepage').length) {
            setTimeout (() => {
                this.$element.removeClass('folded')
                this.$element.each(() => {
                    this.$element.addClass('unfolding')
                    setTimeout(() => {
                        this.$element.removeClass('unfolding')
                    }, 3200)
                })
            }, 100)
        } else {
            this.$element.removeClass('folded')
        }
    }
}


// WEBPACK FOOTER //
// ./components/Guide.js